
import Vue from 'vue'
import Component from 'vue-class-component'
import CardTable from '../components/Layout/CardTable.vue'

// Used for notifications.
import { INotificationService } from '../services/NotificationService'
import SchoolsService from '@/services/SchoolsService'
import ErrorHandlerService from '@/services/ErrorHandlerService'
import { SchoolFunctions } from '@/models/establishment'
import { User as Storeuser } from '../store/index'
import { State } from 'vuex-class'
import GridHeader from '@/models/gridHeader'

@Component({
  components: {
    CardTable,
  },
})
export default class MySchool extends Vue {
  @State private user!: Storeuser
  private functions: SchoolFunctions | undefined = undefined
  private selectedSchoolId: number | null = null
  private isPending: boolean = false
  private headers: GridHeader[] = []
  private errorHandlerService: ErrorHandlerService

  private mounted() {
    this.generateHeaders()
    if (this.user.schools.length === 1) {
      this.selectedSchoolId = this.user.schools[0].etablissement_id
    }
    this.fetchSchoolFunctions()
  }

  private generateHeaders() {
    this.headers.push(
      new GridHeader(
        this.$t('Function').toString(),
        'functions',
        'left',
        true,
        250,
      ),
    )
    this.headers.push(
      new GridHeader(this.$t('Name').toString(), 'membres', 'left', true, 600),
    )
  }

  private async fetchSchoolFunctions() {
    if (this.selectedSchoolId !== undefined && this.selectedSchoolId !== null) {
      this.isPending = true
      try {
        this.functions = await SchoolsService.fetchSchoolFunctions(
          this.selectedSchoolId,
        )
      } catch (error: any) {
        this.errorHandlerService.handle(this, error.response.data.code, true)
      }
      this.isPending = false
    }
  }

  private async onSelectedSchooldId() {
    if (this.selectedSchoolId !== undefined) {
      await this.fetchSchoolFunctions()
    }
  }

  private clearDataTableAndResetSchool() {
    this.selectedSchoolId = null
    this.functions = undefined
  }
}
